import {
  getDefaultAuthorizedPath,
  getRequiredPermissionByPath
} from '@/constants/pagePermissions';

export function getUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}');
  } catch (error) {
    return {};
  }
}

export function getPermissionCodes() {
  const userInfo = getUserInfo();
  return Array.isArray(userInfo.permissionCodes) ? userInfo.permissionCodes : [];
}

export function hasPermission(permissionCode) {
  if (!permissionCode) {
    return true;
  }

  return getPermissionCodes().includes(permissionCode);
}

export function hasRoutePermission(path) {
  const permissionCode = getRequiredPermissionByPath(path);
  return hasPermission(permissionCode);
}

export function resolveDefaultAuthorizedPath() {
  return getDefaultAuthorizedPath(getPermissionCodes());
}
